<template>
  <div class="mt-2" v-if="value">
    <small class="d-block text-muted">Before fix, the value in the DB was:</small>
    <input type="text" class="form-control form-control-sm" :value="value" disabled readonly>
  </div>
</template>

<script>
// Admin-only (the API only sends phones_before_fix to admins): read-only value a phone had before
// the CAM-1532 normalization, shown under the field so a number that went wrong can be traced back.
export default {
  name: 'PhoneBeforeFix',
  props: {
    value: { type: String, default: '' }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PhoneBeforeFix.vue